import { Tab } from '../../../../../modals/product/ProductModal';

export default {
  title: 'Novo produto',
  tabs: {
    [Tab.General]: 'Geral',
    [Tab.NutritionInfo]: 'Informação nutricional',
  },
  form: {
    categories: {
      label: 'Categorias',
    },
    printer: {
      label: 'Impressora',
    },
    name: {
      label: 'Nome',
      placeholder: 'Cheeseburger',
    },
    description: {
      label: 'Descrição',
      placeholder: 'Hambúrguer de vaca 180g, alface, tomates, pepinos, jalapeños e molho yuppi',
    },
    external_id: {
      label: 'Ref. {{integration}}',
      placeholder: 'ex.: referência SKU HubRise',
      read_only_hint:
        'Editável apenas quando uma integração HubRise está ligada e a sincronização do menu está desativada.',
    },
    price: {
      label: 'Preço base',
    },
    has_smart_pricing: {
      label: 'Preços especiais para recolha e entrega',
    },
    pickup_price: {
      label: 'Preço de recolha',
      placeholder: 'Não especificado',
    },
    delivery_price: {
      label: 'Preço de entrega',
      placeholder: 'Não especificado',
    },
    image: {
      label: 'Imagem (opcional)',
    },
    has_combo_tax: {
      label: 'Tem imposto de combo',
    },
    is_available: {
      label: 'Em stock',
      subtitle: 'A mostrar no menu',
    },
    is_visible: {
      label: 'Visível',
      title: 'Visível no menu',
      subtitle_on: 'Os clientes podem ver este item',
      subtitle_off: 'Oculto para todos os clientes',
    },
    is_available_for_pickup: {
      label: 'Disponível para recolha',
      subtitle_on: 'Os clientes podem encomendar para recolha',
      subtitle_off: 'Oculto do menu de recolha',
    },
    is_available_for_delivery: {
      label: 'Disponível para entrega',
      subtitle_on: 'Os clientes podem encomendar para entrega',
      subtitle_off: 'Oculto do menu de entrega',
    },
    modifiers: {
      label: 'Modificadores',
    },
  },
  labels: {
    smart_pricing_update_warning:
      'Ao atualizar, todas as regras de preços inteligentes existentes para este produto serão reescritas.',
    smart_pricing_remove_warning:
      'Após guardar, todas as regras de preços inteligentes existentes para este produto serão removidas.',
  },
  availability: {
    title: 'Disponibilidade',
    helper:
      'A visibilidade é o interruptor principal. Desative um canal para ocultar este item dos clientes de recolha ou entrega sem o remover do menu.',
    status: {
      both: 'Ambos os canais',
      pickup_only: 'Só recolha',
      delivery_only: 'Só entrega',
      hidden: 'Oculto',
      no_channels: 'Sem canais',
    },
    warning: {
      no_channels:
        'Este item é visível mas não está disponível em nenhum canal — os clientes não poderão encomendá-lo.',
    },
    placeholder: '—',
    list_badge: {
      pickup_only: 'Só recolha',
      delivery_only: 'Só entrega',
      no_channels: 'Sem canais',
    },
  },
  buttons: {
    save: 'Guardar',
    close: 'Fechar',
  },
  toasts: {
    changes_got_saved: 'As alterações foram guardadas com sucesso!',
  },
};
